import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { refreshTableTimeSheetToggle } from "../../../stores/actions/TimeSheet";
import { ApplicationState } from "../../../stores/reducers";
import TimesheetsDashboard from 'src/pages/admin/timesheets/timesheet-list';


export const WrapperTimesheetTable = (props: any) => {
    const dispatch = useDispatch();
    const handleRefreshTable = (value: boolean) => {
        dispatch(refreshTableTimeSheetToggle(value));
    };
    const isRefreshTable = useSelector((state: ApplicationState) => state.timeSheet.refreshTablet);

    return <TimesheetsDashboard
        handleResetTableSuccess={handleRefreshTable}
        isRefreshTable={isRefreshTable}
        {...props}
    />
}